//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TextWithIcon from '~/components/other/TextWithIcon'
export default {
  components: {
    TextWithIcon
  },

  data () {
    return {
    }
  },

  computed: {
  }
}
